/* Basic */
import { NgModule, ErrorHandler } from '@angular/core';
import { HttpModule, JsonpModule } from '@angular/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';

/* Native */
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
// // import { PhotoLibrary } from '@ionic-native/photo-library';
import { PhotoLibrary } from './../providers/my-photo-library';
import { PhotoViewer } from '@ionic-native/photo-viewer';
import { Camera } from '@ionic-native/camera';
import { Base64ToGallery } from '@ionic-native/base64-to-gallery';
import { CallNumber } from '@ionic-native/call-number';
import { ImagePicker } from '@ionic-native/image-picker';
import { NativeKeyboard } from '@ionic-native/native-keyboard';
import { Keyboard } from '@ionic-native/keyboard';

/* Pages */
import { TabsPage } from '../pages/tabs/tabs';
import { LoginPage } from '../pages/login/login';
import { PhotoConfirmPage } from '../pages/_com/photo-confirm/photo-confirm';
import { StaffConfirmPasswordModalPage } from "../pages/_com/staff-confirm-password-modal/staff-confirm-password-modal";
import { HoikuchuFukajikoModalPage } from "../pages/_com/hoikuchu-fukajiko-modal/hoikuchu-fukajiko-modal";
import { ReserveListPage } from '../pages/reserve/list/reserve-list';
import { ReserveListBasicPage } from '../pages/reserve/list/basic/reserve-list-basic';
import { ReserveListAgePage } from '../pages/reserve/list/age/reserve-list-age';
import { ReserveDetailPage } from '../pages/reserve/detail/reserve-detail';
import { ReserveEditPage } from '../pages/reserve/edit/reserve-edit';
import { FamilyListPage } from '../pages/family/list/family-list';
import { FamilyDetailPage } from '../pages/family/detail/family-detail';
import { FamilyEditPage } from '../pages/family/edit/family-edit';
import { ChildDetailPage } from '../pages/child/detail/child-detail';
import { ChildEditPage } from '../pages/child/edit/child-edit';
import { PhotoRequestListPage } from '../pages/photo-request/list/photo-request-list';
import { PhotoRequestSelectionPage } from '../pages/photo-request/selection/photo-request-selection';
import { PhotoRequestConfirmPage } from '../pages/photo-request/confirm/photo-request-confirm';
import { PhotoRequestCompletePage } from '../pages/photo-request/complete/photo-request-complete';
import { StaffListPage } from '../pages/staff/list/staff-list';
import { StaffDetailPage } from '../pages/staff/detail/staff-detail';
import { StaffEditPage } from '../pages/staff/edit/staff-edit';
import { FeedPage } from '../pages/feed/feed';
import { ProfilePage } from '../pages/profile/profile';
import { SettingPage } from '../pages/setting/setting';
import { ReserveRequestPage } from '../pages/reserve-request/reserve-request';
import { ReserveEditPhotoRequestMessagePage } from '../pages/photo-request/message-edit/reserve-edit-photo-request-message';
import { SmsFollowPage } from '../pages/sms-follow/sms-follow';
import { PasswordResetPage } from '../pages/password-reset/password-reset';
import { InterviewSheetEditFamilyPage } from '../pages/reserve/interview/edit-family/reserve-interview-edit-family';
import { InterviewSheetDetailStaffPage } from "../pages/reserve/interview/detail-staff/reserve-interview-detail-staff";
import { InterviewSheetEditStaffPage } from "../pages/reserve/interview/edit-staff/reserve-interview-edit-staff";
import { NotebookEditPage } from "../pages/reserve/noteboook/notebook-edit/notebook-edit";
import { NotebookListPage } from "../pages/reserve/noteboook/notebook-list/notebook-list";
import { MessageSheetPage } from '../pages/reserve/messagesheet/reserve-messagesheet';
import { ReservePickupDetailPage } from '../pages/reserve/pickup/detail/reserve-pickup-detail';
import { ReservePickupEditPage } from '../pages/reserve/pickup/edit/reserve-pickup-edit';
import { SignatureDetailPage } from '../pages/signature/detail/signature-detail';
import { SignatureEditPage } from '../pages/signature/edit/signature-edit';
import { SignatureAgreementPage } from "../pages/signature/signature-agreement/signature-agreement";

/* Actions */
import { ReserveAction } from '../actions/reserve.action';
import { FamilyAction } from '../actions/family.action';
import { ChildAction } from '../actions/child.action';
import { ChatAction } from '../actions/chat.action';
import { PhotoAction } from '../actions/photo.action';
import { StaffAction } from '../actions/staff.action';

/* Providers */
import { LoadingService } from '../providers/loading-service';
import { AuthService } from '../providers/auth-service';
import { HttpReserveProvider } from '../providers/http-reserve';
import { HttpChatProvider } from '../providers/http-chat';
import { HttpFamilyProvider } from '../providers/http-family';
import { HttpChildProvider } from '../providers/http-child';
import { HttpConstantProvider } from '../providers/http-constant';
import { HttpStaffProvider } from '../providers/http-staff';
import { HttpRegistProvider } from '../providers/http-regist';

/* State */
import { CompReserveListState } from '../states/comp-reserve-list-state';
import { BasicState } from '../states/basic-state';

/* Stores */
import { AuthStore } from '../stores/auth-store';
import { ConstantsStore } from '../stores/constants-store';
import { BadgeStore } from '../stores/badge-store';

/* Other */
import { MbscModule } from '../lib/mobiscroll/js/mobiscroll.custom-3.2.2.min';
import { ChartModule } from 'angular2-highcharts';
import { ComponentsModule } from "../components/components.module";

const Highcharts = require('highcharts');

let Components = [
  MyApp,
  TabsPage,
  LoginPage,
  ReserveListPage,
  ReserveListBasicPage,
  ReserveListAgePage,
  ReserveDetailPage,
  ReserveEditPage,
  FamilyListPage,
  FamilyDetailPage,
  FamilyEditPage,
  ChildDetailPage,
  ChildEditPage,
  PhotoRequestListPage,
  PhotoRequestSelectionPage,
  PhotoRequestConfirmPage,
  PhotoRequestCompletePage,
  PhotoConfirmPage,
  StaffConfirmPasswordModalPage,
  HoikuchuFukajikoModalPage,
  StaffListPage,
  StaffDetailPage,
  StaffEditPage,
  ProfilePage,
  FeedPage,
  SettingPage,
  ReserveRequestPage,
  ReserveEditPhotoRequestMessagePage,
  SmsFollowPage,
  PasswordResetPage,
  MessageSheetPage,
  SignatureDetailPage,
  SignatureEditPage,
  InterviewSheetEditFamilyPage,
  InterviewSheetDetailStaffPage,
  InterviewSheetEditStaffPage,
  NotebookEditPage,
  NotebookListPage,
  ReservePickupDetailPage,
  ReservePickupEditPage,
  SignatureAgreementPage
];

@NgModule({
  declarations: Components,
  imports: [
    BrowserModule,
    MbscModule,
    HttpModule,
    BrowserAnimationsModule,
    JsonpModule,
    ComponentsModule,
    ChartModule.forRoot(Highcharts),
    IonicModule.forRoot(MyApp, {
      backButtonText: '',
      iconMode: 'ios',
      modalEnter: 'modal-slide-in',
      modalLeave: 'modal-slide-out',
      tabsPlacement: 'bottom',
      pageTransition: 'ios-transition',
    }),
  ],
  bootstrap: [IonicApp],
  entryComponents: Components,
  providers: [
    StatusBar,
    SplashScreen,
    PhotoLibrary,
    PhotoViewer,
    Camera,
    Base64ToGallery,
    CallNumber,
    ImagePicker,
    NativeKeyboard,
    Keyboard,
    AuthService,
    AuthStore,
    ConstantsStore,
    BadgeStore,
    LoadingService,
    ReserveAction,
    ChildAction,
    FamilyAction,
    ChatAction,
    PhotoAction,
    StaffAction,
    ReserveDetailPage,
    PhotoConfirmPage,
    StaffConfirmPasswordModalPage,
    HoikuchuFukajikoModalPage,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    HttpReserveProvider,
    HttpChatProvider,
    HttpFamilyProvider,
    HttpChildProvider,
    HttpConstantProvider,
    HttpStaffProvider,
    CompReserveListState,
    BasicState,
    HttpRegistProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts